import React, { useState } from "react";
import { Button, Form, FormGroup } from "react-bootstrap";

import { TextInput } from "components/UI/Forms";

import "./OrganizationForm.scss";


const OrganizationForm = (props) => {
  const [name, setName] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    let organization = {
      name: name
    }

    props.handleSubmit(organization);
  };

  const validateForm = () => {
    return name;
  };

  return (
    <div className="organization-form-component text-center">
      <Form onSubmit={handleSubmit}>
        <div className="input-table">
          <TextInput
            id="name"
            label="Name"
            value={name}
            onChange={(event) => { setName(event.target.value) }}
          />
        </div>

        <div className="required-field-text">
          <span className="asterisk">*</span> Required Field
        </div>

        <FormGroup controlId="buttons">
          <Button
            disabled={!validateForm() || props.loading}
            type="submit"
          >
            Submit
          </Button>
          { props.cancelForm &&
            <Button
              className="btn-secondary"
              onClick={props.cancelForm}
            >
              Cancel
            </Button>
          }
        </FormGroup>

      </Form>

    </div>
  );
};

export default OrganizationForm;